<template>
  <nav class="sidebar-nav">
    <VuePerfectScrollbar
      :settings="psSettings"
      class="scroll-area"
      @ps-scroll-y="scrollHandle">
      <ul class="nav">
        <template v-for="(item, index) in navItems">
          <template v-if="item.title">
            <SidebarNavTitle
              v-show="getVisible(item.pages)"
              :key="index"
              :name="item.name"
              :classes="item.class"
              :wrapper="item.wrapper" />
          </template>
          <template v-else-if="item.divider">
            <SidebarNavDivider
              :key="index"
              :classes="item.class" />
          </template>
          <template v-else-if="item.label">
            <SidebarNavLabel
              :key="index"
              :name="item.name"
              :url="item.url"
              :icon="item.icon"
              :label="item.label"
              :classes="item.class" />
          </template>
          <template v-else>
            <template v-if="item.children">
              <!-- First level dropdown -->
              <SidebarNavDropdown
                v-show="getVisible(item.pages)"
                :key="index"
                :name="item.name"
                :url="item.url"
                :icon="item.icon"
                :class="item.navClass">
                <template v-for="(childL1, index1) in item.children">
                  <template v-if="childL1.children">
                    <!-- Second level dropdown -->
                    <SidebarNavDropdown
                      v-show="getVisible(childL1.pages)"
                      :key="index1"
                      :name="childL1.name"
                      :url="childL1.url"
                      :icon="childL1.icon"
                      @click="testClick">
                      <li
                        v-for="(childL2, index2) in childL1.children"
                        :key="index2"
                        class="nav-item">
                        <SidebarNavLink
                          v-show="getVisible(childL2.pages)"
                          :name="childL2.name"
                          :url="childL2.url"
                          :icon="childL2.icon"
                          :badge="childL2.badge"
                          :variant="item.variant" />
                      </li>
                    </SidebarNavDropdown>
                  </template>
                  <template v-else>
                    <SidebarNavItem
                      v-show="getVisible(childL1.pages)"
                      :key="index1"
                      :classes="item.class">
                      <SidebarNavLink
                        :name="childL1.name"
                        :url="childL1.url"
                        :icon="childL1.icon"
                        :badge="childL1.badge"
                        :variant="item.variant" />
                    </SidebarNavItem>
                  </template>
                </template>
              </SidebarNavDropdown>
            </template>
            <template v-else>
              <SidebarNavItem
                v-show="getVisible(item.pages)"
                :key="index"
                :classes="item.class">
                <SidebarNavLink
                  :name="item.name"
                  :url="item.url"
                  :icon="item.icon"
                  :badge="item.badge"
                  :variant="item.variant" />
              </SidebarNavItem>
            </template>
          </template>
        </template>
      </ul>
      <slot />
    </VuePerfectScrollbar>
  </nav>
</template>

<script>
import SidebarNavDivider from "./SidebarNavDivider";
import SidebarNavDropdown from "./SidebarNavDropdown";
import SidebarNavLink from "./SidebarNavLink";
import SidebarNavTitle from "./SidebarNavTitle";
import SidebarNavItem from "./SidebarNavItem";
import SidebarNavLabel from "./SidebarNavLabel";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import config from "@/config";
import errorTags from "@/errorTags";

export default {
  components: {
    SidebarNavDivider,
    SidebarNavDropdown,
    SidebarNavLink,
    SidebarNavTitle,
    SidebarNavItem,
    SidebarNavLabel,
    VuePerfectScrollbar
  },
  props: {
    navItems: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      operatorDetail: null,
      subDetail: null,
      feedback: {
        success: false,
        status: errorTags.request.failed
      },
    };
  },
  computed: {
    psSettings: () => {
      // ToDo: find better rtl fix
      return {
        maxScrollbarLength: 200,
        minScrollbarLength: 40,
        suppressScrollX: getComputedStyle(document.querySelector("html")).direction !== "rtl",
        wheelPropagation: false,
        interceptRailY: styles => ({ ...styles, height: 0 })
      };
    }
  },
  mounted() {
    let cssList = document.querySelectorAll('.router-link-exact-active .router-link-active');
    for(var i = 0; i < cssList.length; i++) {
      cssList[i].parentElement.parentElement.parentElement.parentElement.classList.toggle('open');
    }

    let accountType = this.$store.getters.account[0] ? this.$store.getters.account[0].account_type : null;
    let authRole = this.$store.getters.authorityRole ? this.$store.getters.authorityRole : null;

    if (authRole == 'SUB_PRI') {
      this.getSubDetail();
      this.getAgentDetail();
    }
    else
      if (accountType == 2)
        this.getAgentDetail();
  },
  methods: {
    getAgentDetail() {
      let url = config.accountAgentDetailUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        source_account_id: this.$store.getters.account[0].parent_id,
        target_account_id: this.$store.getters.accountId
      };

      this.$http.post(url, json).then(
        function(response) {
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.operatorDetail = response.data.dt.length > 0 ? response.data.dt[0] : null;
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    getSubDetail() {
      let url = config.accountSubDetailUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        sub_login_id: this.$store.getters.loginId
      };

      this.$http.post(url, json).then(
        function(response) {
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.subDetail = response.data.dt.length > 0 ? response.data.dt[0] : null;
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    getVisible(e) {
      if (e) {
        let masterPages = config.masterPages;
        let operatorPages = config.operatorPages;
        let authRole = this.$store.getters.authorityRole;
        let accountType = this.$store.getters.account[0] ? this.$store.getters.account[0].account_type : null;
        let result = false;
        let pages = e;

        if (authRole && accountType) {
          if (authRole == 'OWNER_PRI' || authRole == 'OWNER_SEC') {
            for (var i = 0; i < pages.length; i++) {
              if (accountType == 3) {
                if (['member', 'reportdownline', 'downlineoperator', 'dailystatementnest', 'dailywinlosenest'].includes(pages[i])) { result = false; break; }
                else { result = true; break; }
              } else if (accountType == 2) {
                if (pages[i] == 'operator') { result = false; break; }
                else {
                  if (this.isSelfOperate(pages[i])) { result = true; break; }
                  else { result = false; break; }
                }
              }
            }
          } else {
            if (this.subDetail) {
              let roles = this.subDetail.authority_option;
              roles =  roles && roles.length > 0 ? roles.split(',') : [];

              for (var i = 0; i < pages.length; i++) {
                if (pages[i] == 'subaccount') {
                  result = false;
                  break;
                }
                if (pages[i] == 'dashboard') {
                  result = true;
                  break;
                }
                if (accountType == 3 && pages[i] == 'member') {
                  result = false;
                  break;
                }
                if (accountType == 2 && pages[i] == 'operator') {
                  result = false;
                  break;
                }
                if (accountType == 2 && (['reportdownline','downlineoperator', 'dailystatementnest', 'dailywinlosenest'].includes(pages[i]))) {
                  result = true;
                  break;
                }
                for (var j = 0; j < roles.length; j++) {

                  if (roles[j] == config.pageParent[pages[i]]) {
                    if (this.isSelfOperate(pages[i])) {
                      result = true;
                      break;
                    } else {
                      result = false;
                      break;
                    }
                  }
                }
              }
            }
          }
        }

        return result;
      } else {
        return true;
      }
    },
    isSelfOperate(page) {
      let arr = config.selfOperateBanPage;
      if (arr.includes(page) && this.operatorDetail && this.operatorDetail.self_operate == false)
        return false;

      return true;
    },
    scrollHandle(evt) {}
  }
};
</script>

<style scoped lang="css">
.scroll-area {
  position: absolute;
  height: 100%;
  margin: auto;
}
</style>
